














import { Component, Vue, Prop } from 'vue-property-decorator';
import { biClick } from '@tencent/fit-bi-sdk';
import { USEABLE_FLAG } from '@/business/couponList';
import { FitWxPhonex } from '@tencent/wphk-ui';
import { language } from '@tencent/ppd-base-libs';
@Component({
  components: {
    FitWxPhonex,
  },
})
export default class InvalidEntry extends Vue {
  @Prop({ default: '' }) public className;

  private get isEn() {
    return language.isEn();
  }

  private get isInvalidCouponPage() {
    return this.$route.query.type === USEABLE_FLAG.INVALID;
  }
  private goToInvalidList() {
    biClick('listpage.expired_click');
    this.$router.push({
      name: 'couponlist',
      query: { type: USEABLE_FLAG.INVALID },
    });
  }
  private goCouponExchange() {
    biClick('listpage.coupon_exchange_click');
    this.$router.push({
      name: 'couponExchange',
    });
  }
}
